var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"root"},[_c('div',[_c('BaseCard',{staticClass:"px-5"},[_c('div',{staticClass:"py-3"},[_c('AccountDetails')],1),_c('hr'),_c('div',{staticClass:"py-3"},[_c('DeleteAccount')],1)])],1),_c('div',[_c('WidgetModule')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }